"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixAstNodesPositions = exports.createShorthandCloser = exports.createShorthandCloserTemplateFromParts = exports.shorthandCloserTemplate = exports.edgesShorthandCloser = exports.getOpenedNodeValue = exports.getOpenedNode = exports.createShorthandOpenerFromPart = exports.createShorthandOpener = exports.layersShorthandOpener = exports.getOpenedLayer = exports.getShorthandLayers = exports.unorderedListShorthandOpener = exports.singleKeywordShorthandOpener = exports.splitShorthandOpener = exports.splitSimpleShorthandOpener = exports.intersectionBeforeOpenerCheck = exports.edgesShorthandOpener = exports.isOpenedInitial = exports.matchDataType = void 0;
var tslib_1 = require("tslib");
var tokenizers_1 = require("../tokenizers");
var shorthands_ast_evaluation_1 = require("./shorthands-ast-evaluation");
var css_data_types_1 = require("../css-data-types");
var shorthand_css_data_1 = require("./shorthand-css-data");
var shorthand_parser_errors_1 = require("./shorthand-parser-errors");
var matchDataType = function (dataType, astNodes, index, prevDataType) { return dataType.predicate(astNodes[index].value, index, astNodes, prevDataType); };
exports.matchDataType = matchDataType;
var getDataTypeMatch = function (astNodes, index, parts, prevDataType) {
    for (var i = 0; i < parts.length; i++) {
        var matchAmount = 0;
        if ((matchAmount = Number((0, exports.matchDataType)(parts[i].dataType, astNodes, index, prevDataType))) > 0) {
            return { matchAmount: matchAmount, matchIndex: i };
        }
    }
    return { matchAmount: 1, matchIndex: -1 };
};
var isOpenedInitial = function (opened, prop, dataType) {
    var openedAst = opened[prop];
    return openedAst.length === 1 && openedAst[0].value.text === dataType.initial;
};
exports.isOpenedInitial = isOpenedInitial;
// TODO: Mark initial in value/origin + Test initials
var getInitialAst = function (value) { return ({
    value: (0, tokenizers_1.createCssValueAST)(value)[0],
}); };
var setInitialOpenedProps = function (shorthandProp, parts, opened, shallow) {
    var e_1, _a, e_2, _b;
    try {
        for (var parts_1 = tslib_1.__values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
            var part = parts_1_1.value;
            var props = shallow || !part.openedProps ? [part.prop] : part.openedProps;
            try {
                for (var props_1 = (e_2 = void 0, tslib_1.__values(props)), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
                    var prop = props_1_1.value;
                    if (opened[prop] === undefined) {
                        if (!part.mandatory) {
                            var initialAst = getInitialAst(part.dataType.initial);
                            opened[prop] = !part.multipleItems ? initialAst : [initialAst];
                        }
                        else {
                            throw new shorthand_parser_errors_1.NoMandatoryPartMatchError(shorthandProp, prop);
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (props_1_1 && !props_1_1.done && (_b = props_1.return)) _b.call(props_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return opened;
};
var setCommonProps = function (parts, nodes, opened) {
    for (var i = 0; i < parts.length && nodes.length > 0; i++) {
        var prop = parts[i].prop;
        if (opened[prop] === undefined) {
            var commonNode = void 0;
            if ((commonNode = nodes.shift())) {
                opened[prop] = commonNode;
            }
        }
    }
    return opened;
};
var edgesShorthandOpener = function (prop, corners) {
    return function (astNodes) {
        var _a;
        if (astNodes.length < 1 || astNodes.length > 4) {
            throw new shorthand_parser_errors_1.InvalidEdgesInputLengthError(prop, astNodes.length);
        }
        var _b = tslib_1.__read(prop.split(shorthand_css_data_1.CSS_PROPERTY_DELIMITER), 2), propPrefix = _b[0], propSuffix = _b[1];
        var prefix = propPrefix + shorthand_css_data_1.CSS_PROPERTY_DELIMITER;
        var suffix = propSuffix ? shorthand_css_data_1.CSS_PROPERTY_DELIMITER + propSuffix : '';
        var edgeIndices = shorthand_css_data_1.EDGE_SHORTHAND_INDICES_BY_LENGTH[astNodes.length - 1];
        var edges = !corners ? shorthand_css_data_1.EDGE_SHORTHAND_EDGES : shorthand_css_data_1.CORNER_SHORTHAND_CORNERS;
        var edgeProp = function (edge) { return "".concat(prefix).concat(edge).concat(suffix); };
        var edgeValue = function (index) { return astNodes[edgeIndices[index]]; };
        return _a = {},
            _a[edgeProp(edges[0])] = edgeValue(0),
            _a[edgeProp(edges[1])] = edgeValue(1),
            _a[edgeProp(edges[2])] = edgeValue(2),
            _a[edgeProp(edges[3])] = edgeValue(3),
            _a;
    };
};
exports.edgesShorthandOpener = edgesShorthandOpener;
var intersectionBeforeOpenerCheck = function (prop, dataTypes) {
    return function (astNodes) {
        var e_3, _a;
        var validateValue = function (value, dataType) {
            if (!dataType.predicate(value)) {
                throw new shorthand_parser_errors_1.InvalidIntersectionValueError(prop, value.text);
            }
        };
        if (astNodes.length === 1) {
            try {
                for (var dataTypes_1 = tslib_1.__values(dataTypes), dataTypes_1_1 = dataTypes_1.next(); !dataTypes_1_1.done; dataTypes_1_1 = dataTypes_1.next()) {
                    var dataType = dataTypes_1_1.value;
                    validateValue(astNodes[0].value, dataType);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (dataTypes_1_1 && !dataTypes_1_1.done && (_a = dataTypes_1.return)) _a.call(dataTypes_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        else if (astNodes.length > 1 && dataTypes.length === astNodes.length) {
            for (var i = 0; i < dataTypes.length; i++) {
                validateValue(astNodes[i].value, dataTypes[i]);
            }
        }
    };
};
exports.intersectionBeforeOpenerCheck = intersectionBeforeOpenerCheck;
var splitSimpleShorthandOpener = function (props) {
    return function (astNodes) {
        var e_4, _a;
        var opened = {};
        try {
            for (var props_2 = tslib_1.__values(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()) {
                var prop = props_2_1.value;
                opened[prop] = astNodes[0];
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return opened;
    };
};
exports.splitSimpleShorthandOpener = splitSimpleShorthandOpener;
var splitShorthandOpener = function (props) {
    return function (astNodes) {
        var e_5, _a;
        var opened = {};
        try {
            for (var props_3 = tslib_1.__values(props), props_3_1 = props_3.next(); !props_3_1.done; props_3_1 = props_3.next()) {
                var prop = props_3_1.value;
                opened[prop] = astNodes;
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (props_3_1 && !props_3_1.done && (_a = props_3.return)) _a.call(props_3);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return opened;
    };
};
exports.splitShorthandOpener = splitShorthandOpener;
var singleKeywordShorthandOpener = function (keywordValueMap, multipleItems) {
    if (multipleItems === void 0) { multipleItems = false; }
    return function (astNodes) {
        var e_6, _a;
        var opened = {};
        var keywordValues = keywordValueMap[astNodes[0].value.text];
        var props = Object.keys(keywordValues);
        try {
            for (var props_4 = tslib_1.__values(props), props_4_1 = props_4.next(); !props_4_1.done; props_4_1 = props_4.next()) {
                var prop = props_4_1.value;
                var initialAst = getInitialAst(keywordValues[prop]);
                opened[prop] = !multipleItems ? initialAst : [initialAst];
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (props_4_1 && !props_4_1.done && (_a = props_4.return)) _a.call(props_4);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return opened;
    };
};
exports.singleKeywordShorthandOpener = singleKeywordShorthandOpener;
var unorderedListShorthandOpener = function (parts, _a) {
    var _b = _a === void 0 ? {} : _a, shallow = _b.shallow, commonValue = _b.commonValue;
    return function (astNodes, api) {
        var opened = {};
        var unfoundParts = tslib_1.__spreadArray([], tslib_1.__read(parts), false);
        var commonMatch = commonValue ? (0, css_data_types_1.unorderedListPredicate)(commonValue) : function () { return false; };
        var commonNodes = [];
        var prevDataType = css_data_types_1.DataTypeType.Unknown;
        for (var index = 0; index < astNodes.length;) {
            var currNode = astNodes[index];
            if (commonValue && commonMatch(currNode.value)) {
                commonNodes.push(astNodes[index++]);
                continue;
            }
            var dataTypeMatch = getDataTypeMatch(astNodes, index, unfoundParts, prevDataType);
            var matchAmount = dataTypeMatch.matchAmount, matchIndex = dataTypeMatch.matchIndex;
            var foundPart = unfoundParts[matchIndex];
            if (matchIndex !== -1 && foundPart) {
                var matchLength = matchAmount;
                var prop = foundPart.prop, dataType = foundPart.dataType, partOpener = foundPart.partOpener, beforeOpenerCheck = foundPart.beforeOpenerCheck, multipleItems = foundPart.multipleItems, multipleSplit = foundPart.multipleSplit;
                beforeOpenerCheck === null || beforeOpenerCheck === void 0 ? void 0 : beforeOpenerCheck(astNodes);
                if (dataType.prefix && currNode.value.text === dataType.prefix.prefixChar) {
                    currNode = astNodes[++index];
                    matchLength--;
                }
                var nodes = matchLength === 1 ? currNode : astNodes.slice(index, index + matchLength);
                if (shallow || !partOpener) {
                    opened[prop] = multipleItems
                        ? (!multipleSplit ? opened[prop] || [] : []).concat(nodes)
                        : nodes;
                }
                else {
                    opened = tslib_1.__assign(tslib_1.__assign({}, opened), partOpener(Array.isArray(nodes) ? nodes : [nodes], api));
                }
                unfoundParts.splice(matchIndex, 1);
                prevDataType = dataType.dataType;
                index += matchLength;
            }
            else {
                throw new shorthand_parser_errors_1.NoDataTypeMatchError(currNode.value.text);
            }
        }
        if (commonValue) {
            opened = setCommonProps(parts, commonNodes, opened);
        }
        return opened;
    };
};
exports.unorderedListShorthandOpener = unorderedListShorthandOpener;
var getShorthandLayers = function (astNodes, seperator) {
    var e_7, _a;
    if (seperator === void 0) { seperator = css_data_types_1.DEFAULT_LAYER_SEPERATOR; }
    var layers = [];
    var layerIndex = 0;
    try {
        for (var astNodes_1 = tslib_1.__values(astNodes), astNodes_1_1 = astNodes_1.next(); !astNodes_1_1.done; astNodes_1_1 = astNodes_1.next()) {
            var node = astNodes_1_1.value;
            if (node.value.text === seperator) {
                layerIndex++;
                continue;
            }
            if (!layers[layerIndex]) {
                layers[layerIndex] = [];
            }
            layers[layerIndex].push(node);
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (astNodes_1_1 && !astNodes_1_1.done && (_a = astNodes_1.return)) _a.call(astNodes_1);
        }
        finally { if (e_7) throw e_7.error; }
    }
    return layers;
};
exports.getShorthandLayers = getShorthandLayers;
var getOpenedLayer = function (opened, index, multipleItemProps) {
    var e_8, _a;
    var layer = {};
    var props = Object.keys(opened);
    var hasValue = false;
    try {
        for (var props_5 = tslib_1.__values(props), props_5_1 = props_5.next(); !props_5_1.done; props_5_1 = props_5.next()) {
            var prop = props_5_1.value;
            var value = opened[prop];
            if (!value) {
                continue;
            }
            if (multipleItemProps && multipleItemProps.includes(prop)) {
                var valueInIndex = value[index];
                if (!Array.isArray(valueInIndex)) {
                    if (index === 0) {
                        layer[prop] = value;
                    }
                }
                else {
                    layer[prop] = valueInIndex;
                }
            }
            else {
                layer[prop] = index === 0 && !Array.isArray(value) ? value : value[index];
            }
            if (layer[prop]) {
                hasValue = true;
            }
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (props_5_1 && !props_5_1.done && (_a = props_5.return)) _a.call(props_5);
        }
        finally { if (e_8) throw e_8.error; }
    }
    return hasValue ? layer : undefined;
};
exports.getOpenedLayer = getOpenedLayer;
var layersShorthandOpener = function (prop, singleLayerOpener, singleLayerParts, lastLayerOpener, lastLayerParts) {
    return function (astNodes, api) {
        var e_9, _a, e_10, _b;
        var layers = (0, exports.getShorthandLayers)(astNodes);
        var openedLayers = (!lastLayerOpener ? layers : layers.slice(0, -1)).map(function (layer) {
            return setInitialOpenedProps(prop, singleLayerParts, singleLayerOpener(layer, api));
        });
        if (lastLayerOpener) {
            openedLayers = openedLayers.concat([
                setInitialOpenedProps(prop, lastLayerParts || [], lastLayerOpener(layers[layers.length - 1], api)),
            ]);
        }
        if (layers.length === 1) {
            return openedLayers[0];
        }
        var opened = {};
        try {
            for (var openedLayers_1 = tslib_1.__values(openedLayers), openedLayers_1_1 = openedLayers_1.next(); !openedLayers_1_1.done; openedLayers_1_1 = openedLayers_1.next()) {
                var layer = openedLayers_1_1.value;
                var layerProps = Object.keys(layer);
                try {
                    for (var layerProps_1 = (e_10 = void 0, tslib_1.__values(layerProps)), layerProps_1_1 = layerProps_1.next(); !layerProps_1_1.done; layerProps_1_1 = layerProps_1.next()) {
                        var prop_1 = layerProps_1_1.value;
                        var existingValue = opened[prop_1];
                        var propValue = layer[prop_1];
                        if (!existingValue) {
                            opened[prop_1] = propValue;
                        }
                        else {
                            if (!Array.isArray(propValue)) {
                                opened[prop_1] = Array.isArray(existingValue)
                                    ? existingValue.concat(propValue)
                                    : [existingValue, propValue];
                            }
                            else {
                                opened[prop_1] = Array.isArray(existingValue[0])
                                    ? existingValue.concat([propValue])
                                    : [existingValue, propValue];
                            }
                        }
                    }
                }
                catch (e_10_1) { e_10 = { error: e_10_1 }; }
                finally {
                    try {
                        if (layerProps_1_1 && !layerProps_1_1.done && (_b = layerProps_1.return)) _b.call(layerProps_1);
                    }
                    finally { if (e_10) throw e_10.error; }
                }
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (openedLayers_1_1 && !openedLayers_1_1.done && (_a = openedLayers_1.return)) _a.call(openedLayers_1);
            }
            finally { if (e_9) throw e_9.error; }
        }
        return opened;
    };
};
exports.layersShorthandOpener = layersShorthandOpener;
var getShorthandPartsProps = function (parts, shallow) {
    var e_11, _a;
    var partsProps = [];
    try {
        for (var parts_2 = tslib_1.__values(parts), parts_2_1 = parts_2.next(); !parts_2_1.done; parts_2_1 = parts_2.next()) {
            var part = parts_2_1.value;
            partsProps = partsProps.concat(shallow || !part.openedProps ? part.prop : part.openedProps);
        }
    }
    catch (e_11_1) { e_11 = { error: e_11_1 }; }
    finally {
        try {
            if (parts_2_1 && !parts_2_1.done && (_a = parts_2.return)) _a.call(parts_2);
        }
        finally { if (e_11) throw e_11.error; }
    }
    return partsProps;
};
var openSingleKeywordShorthand = function (shorthandProp, partProps, astNodes, api, part) {
    var _a;
    var opened = {};
    if (astNodes.length === 1) {
        var node = astNodes[0];
        var universalPart = {
            prop: shorthandProp,
            dataType: css_data_types_1.universalDataType,
            partOpener: (0, exports.splitSimpleShorthandOpener)(partProps),
        };
        /* Identify shorthand single-keyword with predicate */
        var matchingPart = part && part.dataType.predicate(node.value)
            ? part
            : universalPart.dataType.predicate(node.value)
                ? universalPart
                : undefined;
        if (matchingPart) {
            /* Return the opened single-keyword shorthand, using opener if it exists */
            opened = matchingPart.partOpener ? matchingPart.partOpener([node], api) : (_a = {}, _a[matchingPart.prop] = node, _a);
        }
    }
    return opened;
};
var createShorthandOpener = function (_a) {
    var prop = _a.prop, singleKeywordPart = _a.singleKeywordPart, parts = _a.parts, shorthandOpener = _a.shorthandOpener;
    return function (shortHand, api, shallow) {
        /* Evaluate the full input AST */
        var astNodes = (0, shorthands_ast_evaluation_1.evaluateAst)(shortHand, api);
        /* Try opening the shorthand as a single keyword and return it if so */
        var singleKeywordOpened = openSingleKeywordShorthand(prop, getShorthandPartsProps(parts, shallow), astNodes, api, singleKeywordPart);
        if (Object.keys(singleKeywordOpened).length > 0) {
            return singleKeywordOpened;
        }
        // TODO: Catch errors and return some value on error?
        /* Open the shorthand using the provided method */
        var opened = shorthandOpener(astNodes, api, parts, shallow);
        /* Return the opened shorthand, after setting missing initial values */
        return setInitialOpenedProps(prop, parts, opened, shallow);
    };
};
exports.createShorthandOpener = createShorthandOpener;
var createShorthandOpenerFromPart = function (part) {
    return (0, exports.createShorthandOpener)({
        prop: part.prop,
        parts: [part],
        shorthandOpener: function (astNodes, api, _parts, shallow) {
            return part.partOpener ? part.partOpener(astNodes, api, shallow) : {};
        },
    });
};
exports.createShorthandOpenerFromPart = createShorthandOpenerFromPart;
var getOpenedNode = function (nodeOrNodes, api, detachExpressions, multiExpressions) {
    if (detachExpressions === void 0) { detachExpressions = false; }
    if (multiExpressions === void 0) { multiExpressions = []; }
    if (Array.isArray(nodeOrNodes)) {
        return nodeOrNodes.reduce(function (values, node) { return values.concat((0, exports.getOpenedNode)(node, api, detachExpressions, multiExpressions)); }, []);
    }
    var origin = nodeOrNodes.origin;
    if (!origin || detachExpressions) {
        return [nodeOrNodes.value];
    }
    var expression = api.toString(origin);
    if (multiExpressions.includes(expression)) {
        return [];
    }
    if (api.getValue(origin).length > 1) {
        multiExpressions.push(expression);
    }
    return [origin];
};
exports.getOpenedNode = getOpenedNode;
var getOpenedNodeValue = function (nodes, api) {
    return nodes
        .reduce(function (value, node) { return value + ((0, tokenizers_1.isCSSCodeAst)(node) ? (0, tokenizers_1.getFullText)(node) : ' ' + api.toString(node)); }, '')
        .trim();
};
exports.getOpenedNodeValue = getOpenedNodeValue;
var edgesShorthandCloser = function (prop, corners) {
    return function (opened, api, detachExpressions) {
        if (detachExpressions === void 0) { detachExpressions = false; }
        var _a = tslib_1.__read(prop.split(shorthand_css_data_1.CSS_PROPERTY_DELIMITER), 2), propPrefix = _a[0], propSuffix = _a[1];
        var prefix = propPrefix + shorthand_css_data_1.CSS_PROPERTY_DELIMITER;
        var suffix = propSuffix ? shorthand_css_data_1.CSS_PROPERTY_DELIMITER + propSuffix : '';
        var edges = !corners ? shorthand_css_data_1.EDGE_SHORTHAND_EDGES : shorthand_css_data_1.CORNER_SHORTHAND_CORNERS;
        var multiExpressions = [];
        var edgeProp = function (edge) { return "".concat(prefix).concat(edge).concat(suffix); };
        var edgeValue = function (index) {
            return (0, exports.getOpenedNode)(opened[edgeProp(edges[index])], api, detachExpressions, multiExpressions);
        };
        var edgeNodes = [edgeValue(0), edgeValue(1), edgeValue(2), edgeValue(3)];
        var edgeValues = edgeNodes.map(function (nodes) { return (0, exports.getOpenedNodeValue)(nodes, api); });
        if (edgeValues[3] === edgeValues[1]) {
            edgeNodes.pop();
            edgeValues.pop();
            if (edgeValues[2] === edgeValues[0]) {
                edgeNodes.pop();
                edgeValues.pop();
                if (edgeValues[1] === edgeValues[0]) {
                    edgeNodes.pop();
                    edgeValues.pop();
                }
            }
        }
        return (0, exports.fixAstNodesPositions)(edgeNodes.filter(function (nodes) { return nodes.length > 0; }).map(function (nodes) { return nodes[0]; }), api);
    };
};
exports.edgesShorthandCloser = edgesShorthandCloser;
var shorthandCloserTemplate = function (strings) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return ({ strings: strings, keys: keys });
};
exports.shorthandCloserTemplate = shorthandCloserTemplate;
var createShorthandCloserTemplateFromParts = function (parts) {
    var keys = parts.map(function (_a) {
        var prop = _a.prop;
        return prop;
    });
    return {
        keys: keys,
        strings: [''].concat(Array(keys.length).fill(' ')),
    };
};
exports.createShorthandCloserTemplateFromParts = createShorthandCloserTemplateFromParts;
var createShorthandCloser = function (template) {
    return function (opened, api, detachExpressions) {
        if (detachExpressions === void 0) { detachExpressions = false; }
        var multiExpressions = [];
        return (0, exports.fixAstNodesPositions)(template.strings.reduce(function (nodes, currString, index) {
            var currKey = template.keys[index];
            return currKey === undefined
                ? nodes
                : nodes.concat((0, tokenizers_1.valueTextNode)(currString), (0, exports.getOpenedNode)(opened[currKey], api, detachExpressions, multiExpressions));
        }, []), api);
    };
};
exports.createShorthandCloser = createShorthandCloser;
var fixAstNodesPositions = function (nodes, api, start) {
    if (start === void 0) { start = 0; }
    var currPosition = start;
    var fixedNodes = [];
    nodes.forEach(function (node) {
        var nodeText = '';
        if ((0, tokenizers_1.isCSSCodeAst)(node)) {
            nodeText = node.text.trim();
            if (nodeText.length === 0) {
                return;
            }
            var before_1 = [];
            if (fixedNodes.length > 0 && nodeText !== ',') {
                // Trailing spaces are added only after the first valid node
                before_1.push({
                    type: 'space',
                    value: ' ',
                    start: currPosition,
                    end: currPosition + 1,
                });
                currPosition++;
            }
            var args = [];
            if (node.type === 'call') {
                args = (0, exports.fixAstNodesPositions)(node.args, api, 
                // Current position + function name + (
                currPosition + node.name.length + 1);
            }
            fixedNodes.push(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, node), (nodeText === '/' ? { type: '/' } : nodeText === ',' ? { type: ',' } : {})), { text: nodeText, start: currPosition, end: currPosition + nodeText.length, before: before_1 }), (args.length > 0 ? { args: args } : {})));
        }
        else {
            nodeText = api.toString(node);
            if (fixedNodes.length > 0) {
                currPosition++; // To account for a space before non-first expression nodes
            }
            fixedNodes.push(node);
        }
        currPosition += nodeText.length;
    });
    return fixedNodes;
};
exports.fixAstNodesPositions = fixAstNodesPositions;
//# sourceMappingURL=shorthand-parser-utils.js.map